import { render } from "./TrainingRncpAccordionComponent.vue?vue&type=template&id=30f4d4e6&scoped=true"
import script from "./TrainingRncpAccordionComponent.vue?vue&type=script&lang=js"
export * from "./TrainingRncpAccordionComponent.vue?vue&type=script&lang=js"

import "./TrainingRncpAccordionComponent.vue?vue&type=style&index=0&id=30f4d4e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f4d4e6"]])

export default __exports__